import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import "./legal.scss";

export default function PrivacyPage() {
  return (
    <div id="legal-page">
      <div className="legal-bg" aria-hidden="true" style={{ "--legal-bg-image": 'url("/landing/bobspace.webp")' }} />
      <Nav useSmoothScroll={false} />

      <main className="legal-main">
        <section className="legal-card">
          <p className="legal-kicker">Legal</p>
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: May 8, 2026</p>

          <h2>1. Information We Collect</h2>
          <p>
            We may collect wallet addresses, connected account identifiers, task completion status, and basic technical data required
            to operate the website and community features.
          </p>

          <h2>2. How We Use Information</h2>
          <p>
            Data is used to provide functionality such as account linking, task verification, leaderboard scoring, abuse prevention,
            and service reliability.
          </p>

          <h2>3. Wallet and Public Blockchain Data</h2>
          <p>
            Blockchain data is public by nature. Interactions associated with your wallet may be visible on-chain and through third-party
            explorers and analytics services.
          </p>

          <h2>4. Third-Party Integrations</h2>
          <p>
            When you connect external services (such as wallet providers or social platforms), their respective privacy policies also apply.
            We only request data needed for declared features.
          </p>

          <h2>5. Data Retention</h2>
          <p>
            We retain data for as long as reasonably needed to provide services, maintain security, and enforce task and reward integrity.
          </p>

          <h2>6. Security</h2>
          <p>
            We use reasonable measures to protect data, but no system is completely secure. You are responsible for keeping your wallet
            and account credentials safe.
          </p>

          <h2>7. Your Choices</h2>
          <p>
            You may stop using the services at any time and disconnect linked services where available. Public blockchain records cannot
            be deleted by us.
          </p>

          <h2>8. Policy Updates</h2>
          <p>
            We may revise this Privacy Policy from time to time. Updated versions will be posted on this page with a revised date.
          </p>

          <h2>9. Contact</h2>
          <p>
            For privacy-related questions, contact the team through official Bob Monad channels listed on the website.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
}

